export enum Notes {
  RequestorComments = 'C',
  PublicNote = 'P',
  PrivateNote = 'R',
}
